import React, { useEffect } from 'react';
import { ListSortControl } from '@ui/ListSortControl';
import {
  SortProjectsOptions,
  useSortProjectsBy,
  useSortProjectsDirection,
  setSortProjectsBy,
  setSortProjectsDirection,
} from '@client/hooks/use-filter-projects.hooks';
import { SortByAlternativeKey } from '@shared/helpers/tree.helpers';

const SORT_OPTIONS: Partial<
  Record<SortByAlternativeKey<SortProjectsOptions>, string>
> = {
  owner: 'Project owner',
  name: 'Project name',
  gfa: 'Gross floor area',
  co2: 'Carbon per m²',
  cost: 'Expenses per m²',
  completed_at: 'Completion date',
  updated_at: 'Last updated',
};

export const ProjectSortControl = () => {
  const sortBy = useSortProjectsBy();
  const direction = useSortProjectsDirection();
  useEffect(() => {
    if (sortBy === 'target') setSortProjectsBy('name');
  }, [sortBy]);
  return (
    <ListSortControl
      value={sortBy === 'target' ? 'name' : sortBy}
      options={SORT_OPTIONS}
      direction={direction}
      onChange={setSortProjectsBy}
      onDirectionChange={setSortProjectsDirection}
      preserveOptionOrder
    />
  );
};
